// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fhFt6N5dNLK8MS {\n  height: 32px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 70%;\n  margin: 0 auto;\n}\n.fhFt6N5dNLK8MS::before {\n  content: '';\n  display: block;\n  width: 100%;\n  border-top: 2px solid var(--ds-border, #091e4224);\n}\n.fhFt6N5dNLK8MS:focus {\n  outline: none;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCardFront": "fhFt6N5dNLK8MS"
};
export default ___CSS_LOADER_EXPORT___;
